import React from 'react';
import PropTypes from 'prop-types';
import { hackyServerSideTranslations } from '../i18nNext';
import * as Sentry from '@sentry/nextjs';
import { Partners } from '../components/partners/Partners';
import { getStages } from '../store/partners/partners.service';
import { buildSimpleHead } from '../components/layout/heading';
import { buildGuestOrLoggedInLayout } from '../components/layout/layoutBuilder';
import { cdnize } from '../utils/pureUtils';

const PartnersPage = ({ stages }) => {
  return <Partners preloadedStages={stages} />;
};

PartnersPage.propTypes = {
  stages: PropTypes.array
};

PartnersPage.getHead = () => props => {
  const DefaultHeader = buildSimpleHead('partners');

  const imageLink = cdnize('/meta/partners-meta.jpg');

  return <DefaultHeader {...props} twitterImageLink={imageLink} imageLink={imageLink} />;
};

export async function getStaticProps({ locale }) {
  const i18nConfig = await hackyServerSideTranslations(locale);
  try {
    const stages = await getStages();
    return { props: { stages, ...i18nConfig } };
  } catch (e) {
    Sentry.captureException(e);
    return { props: { stages: null, ...i18nConfig } };
  }
}

PartnersPage.getLayout = buildGuestOrLoggedInLayout();
PartnersPage.getLayoutProps = () => ({ showMenu: false });

export default PartnersPage;
